import { headerApiService } from "../api-services/headerApiServices";
import { sessionApiService } from "../api-services/sessionApiServices";
import {
    updateSessionInfo,
    updatePartialSessionInfo,
} from "../store/user-details/slice";

async function updateSession(sessionUpdateType, updateData, dispatch) {
    try {
        const response = await sessionApiService.updateSession(
            sessionUpdateType,
            updateData
        );
        dispatch(updateSessionInfo(response.data));
        return response.data;
    } catch (error) {
        console.error(
            "Error updating session:",
            error.response?.data || error.message
        );
    }
}

async function manageLoggedOutUserSession(
    sessionUpdateType,
    updateData,
    dispatch
) {
    try {
        switch (sessionUpdateType) {
            case "HOOKCITY":
                const hookCentreDetails =
                    await headerApiService.getHookCentreDetails(
                        updateData.hookCityId
                    );
                dispatch(
                    updatePartialSessionInfo({
                        centreDetails: {
                            cityId: hookCentreDetails.cityId,
                            centreId: hookCentreDetails.centreId,
                        },
                    })
                );
                break;
            case "CENTRE":
                dispatch(
                    updatePartialSessionInfo({
                        ...updateData,
                    })
                );
                break;
            default:
                break;
        }

        return;
    } catch (error) {
        console.error(
            "Error updating session:",
            error.response?.data || error.message
        );
    }
}

export { updateSession, manageLoggedOutUserSession };
